export const enum SnackType {
  Success = 'SNACK_SUCCESS',
  Error = 'SNACK_ERROR',
  Warning = 'SNACK_WARNING',
  Info = 'SNACK_INFO',
}
